<template>
    <form-row title="Have you sent your copy of the purchase contract to your Loan Officer?">
        <div class="flex flex-col sm:flex-row flex-1 sm:items-center">
            <input-radio-boolean
                name="has_sent_copy_to_loan_officer"
                v-model="has_been_sent"
                true="Yes"
                false="No"
                :read_only="read_only"
            />

            <input-date
                v-if="has_been_sent"
                class="mt-4 sm:mt-0 sm:ml-12 flex flex-1 items-center sm:justify-end"
                label="Date Sent:"
                :value="mortgage.sent_copy_to_loan_officer_at"
                name="sent_copy_to_loan_officer_at"
                :read_only="read_only"
            />
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        mortgage: {},
        read_only: { default: false },
    },

    data() {
        return {
            has_been_sent: this.mortgage.has_sent_copy_to_loan_officer,
        }
    },
}
</script>
